export const list = (dispatch, apiClient) => apiClient
  .call({ endpoint: 'article/list' })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ARTICLES_SET', articles: res.data });
    return res;
  });

export const list2 = (dispatch, apiClient, query, skipId) => apiClient
  .call({ endpoint: 'article/list2', data: { query, skipId } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ARTICLES_SET', articles: res.data.results });
    return res;
  });

export const find = (dispatch, apiClient, query) => apiClient
  .call({ endpoint: 'article/find', data: { query } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ARTICLES_SET', articles: res.data });
    return res;
  });

export const create = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'article/new', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ARTICLES_SET', articles: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, data) => apiClient
  .call({ endpoint: 'article/update', data: { ...data, id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ARTICLES_SET', articles: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'article/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ARTICLES_SET', articles: res.data.article });
    dispatch({ type: 'STOCK_SET', payload: res.data.stock });
    return res;
  });

export const move = (dispatch, apiClient, article, from, to, count) => apiClient
  .call({ endpoint: 'article/move', data: { article, from, to, count } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'STOCK_SET', payload: [res.data.from, res.data.to] });
    return res;
  });

export const move2 = (dispatch, apiClient, articles, from, to) => apiClient
  .call({ endpoint: 'article/move2', data: { articles, from, to } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'STOCK_SET', payload: res.data.stock });
    return res;
  });

export const verifyStock = (dispatch, apiClient, articles, location, locationDiff) => apiClient
  .call({ endpoint: 'article/verifyStock', data: { articles, location, locationDiff } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/articles.js